import { Button, Input, Select, Space, Switch, TimePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import {
  informerClientSelectFilterOption,
  normalizeInformerTargetClientIds,
} from '../../utils/cabinetMarketingUtils';

const CabinetTelegramBroadcastsTab = ({
  sectionDirty,
  sectionSaving,
  handleSaveMarketingSection,
  cabinetTelegram,
  patchCabinetTelegram,
  mergeInformerAudienceOptions,
  informerClientsListLoading,
  handleTelegramDirty,
}) => {
  const handleAddBroadcast = () => {
    const id = `tb_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    patchCabinetTelegram((p) => ({
      ...p,
      broadcasts: [
        ...(p.broadcasts || []),
        {
          id,
          name: '',
          template: '',
          target_client_ids: [],
          send_time_hhmm: '12:00',
          enabled: false,
          last_sent_local_date: null,
        },
      ],
    }));
    handleTelegramDirty('broadcasts');
  };

  const handlePatchBroadcast = (idx, patch) => {
    patchCabinetTelegram((p) => {
      const next = [...(p.broadcasts || [])];
      next[idx] = { ...next[idx], ...patch };
      return { ...p, broadcasts: next };
    });
    handleTelegramDirty('broadcasts');
  };

  const handleRemoveBroadcast = (idx) => {
    patchCabinetTelegram((p) => {
      const next = [...(p.broadcasts || [])].filter((_, i) => i !== idx);
      return { ...p, broadcasts: next };
    });
    handleTelegramDirty('broadcasts');
  };

  return (
    <div className="sett-card sett-telegram-broadcasts-card">
      <div className="sett-card__header sett-card__header--row">
        <h3 className="sett-card__title">Рассылки Telegram</h3>
        <Button
          type={sectionDirty.broadcasts ? 'primary' : 'default'}
          disabled={!sectionDirty.broadcasts}
          loading={sectionSaving.broadcasts}
          onClick={() => handleSaveMarketingSection('broadcasts')}
          aria-label="Сохранить рассылки Telegram"
        >
          Сохранить
        </Button>
      </div>
      <div className="sett-card__body">
        <p className="sett-cell--muted" style={{ marginBottom: 12 }}>
          Рассылки по расписанию (локальное время из настроек уведомлений). Клиенты получают сообщения, если
          привязан telegram_id.
        </p>
        <Space align="center" style={{ marginBottom: 8 }} wrap>
          <span className="sett-cell--muted">Шаблоны рассылок</span>
          <Button type="default" size="small" onClick={handleAddBroadcast}>
            Добавить шаблон рассылки
          </Button>
        </Space>
        {(cabinetTelegram.broadcasts || []).map((br, idx) => (
          <div
            key={br.id || idx}
            style={{
              marginBottom: 12,
              padding: 12,
              border: '1px solid var(--pm-border-table)',
              borderRadius: 8,
            }}
          >
            <Space wrap style={{ marginBottom: 8 }}>
              <Switch
                checked={!!br.enabled}
                onChange={(c) => handlePatchBroadcast(idx, { enabled: c })}
                aria-label="Включить рассылку"
              />
              <Input
                placeholder="Название"
                value={br.name || ''}
                onChange={(e) => handlePatchBroadcast(idx, { name: e.target.value })}
                style={{ width: 200 }}
              />
              <TimePicker
                format="HH:mm"
                value={br.send_time_hhmm ? dayjs(br.send_time_hhmm, 'HH:mm') : null}
                onChange={(t) => {
                  const v = t && t.isValid() ? t.format('HH:mm') : '12:00';
                  handlePatchBroadcast(idx, { send_time_hhmm: v });
                }}
              />
              <Button type="text" danger size="small" onClick={() => handleRemoveBroadcast(idx)}>
                Удалить
              </Button>
            </Space>
            <Input.TextArea
              rows={3}
              value={br.template || ''}
              onChange={(e) => handlePatchBroadcast(idx, { template: e.target.value })}
              style={{ marginBottom: 8 }}
            />
            <Select
              mode="multiple"
              showSearch
              allowClear
              optionFilterProp="label"
              filterOption={informerClientSelectFilterOption}
              notFoundContent={informerClientsListLoading ? 'Загрузка…' : 'Нет совпадений'}
              placeholder="Клиенты (нужен telegram_id для доставки)"
              value={normalizeInformerTargetClientIds(br.target_client_ids)}
              options={mergeInformerAudienceOptions(br.target_client_ids || [])}
              onChange={(ids) => {
                handlePatchBroadcast(idx, {
                  target_client_ids: normalizeInformerTargetClientIds(ids || []),
                });
              }}
              style={{ width: '100%', maxWidth: 520 }}
              loading={informerClientsListLoading}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CabinetTelegramBroadcastsTab;
